// extracted by mini-css-extract-plugin
export const accountBreakdown = "Breakdown__accountBreakdown__-699j";
export const actualValue = "Breakdown__actualValue__z46BK";
export const actualValuesLabel = "Breakdown__actualValuesLabel__fBLaj";
export const atlasGrotesk = "'AtlasGrotesk'";
export const bar = "Breakdown__bar__-7Pc4";
export const barContainer = "Breakdown__barContainer__99wd6";
export const bold = "700";
export const breakdown = "Breakdown__breakdown__-N63U";
export const breakdownChart = "Breakdown__breakdownChart__cw0XE";
export const breakdownWrapper = "Breakdown__breakdownWrapper__5KA55";
export const chartContainer = "Breakdown__chartContainer__Sgx6U";
export const ctaWrapper = "Breakdown__ctaWrapper__3nx4g";
export const expanded = "Breakdown__expanded__pH-bx";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const hidden = "Breakdown__hidden__-Alyl";
export const icon = "Breakdown__icon__0VRkg";
export const legendWrapper = "Breakdown__legendWrapper__3HxKS";
export const light = "Breakdown__light__awuKp";
export const limitIcon = "Breakdown__limitIcon__n5F2T";
export const limitIconWrapper = "Breakdown__limitIconWrapper__iPzkq";
export const medium = "500";
export const member = "Breakdown__member__3motv";
export const name = "Breakdown__name__7x8+s";
export const nameWrapper = "Breakdown__nameWrapper__lE60L";
export const others = "Breakdown__others__T9oPZ";
export const overlappedZeroValue = "Breakdown__overlappedZeroValue__w7vG9";
export const overlay = "Breakdown__Overlay__J9uRH";
export const peers = "Breakdown__peers__X2Gq1";
export const projectionBar = "Breakdown__projectionBar__-+uyq";
export const projectionTooltipContainer = "Breakdown__projectionTooltipContainer__X-YfS";
export const projectionValue = "Breakdown__projectionValue__MpT4G";
export const projectionValuesLabel = "Breakdown__projectionValuesLabel__8NkIE";
export const regular = "400";
export const sans = "'sans'";
export const seeAllButtonRow = "Breakdown__seeAllButtonRow__tc++a";
export const semibold = "600";
export const serif = "'serif'";
export const textCenter = "Breakdown__textCenter__anUJk";
export const tooltipContainer = "Breakdown__tooltipContainer__iMUZ6";
export const valueLabels = "Breakdown__valueLabels__7ToU+";
export const withProjections = "Breakdown__withProjections__fCcVn";